import {useOktaAuth} from '@okta/okta-react';
import {useCallback} from 'react';

export function useAuth() {
    const { authState, oktaAuth } = useOktaAuth();

    const login = useCallback(() => {
        oktaAuth.signInWithRedirect();
    }, [oktaAuth]);

    const logout = useCallback(() => {
        oktaAuth.revokeAccessToken();
    }, [oktaAuth]);

    const getAccessToken = useCallback(async () => {
        if (!authState?.isAuthenticated) {
            login();
            return null;
        }

        try {
            const accessToken = await oktaAuth.tokenManager.get('accessToken');
            return accessToken?.accessToken || null;
        } catch (err) {
            console.error('Error getting access token:', err);
            login();
            return null;
        }
    }, [authState, oktaAuth, login]);

    return {
        authState,
        isAuthenticated: !!authState?.isAuthenticated,
        login,
        logout,
        getAccessToken
    };
}
